import { useState } from "react";
import "../../Styles/navbar.css";
import { useNavigate } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import NavbarSideBar from "../../components/NavbarSideBar";

const Navbar = ({ setUpdatePage, updatePage }) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  return (
    <>
      <NavbarSideBar show={show} setShow={setShow} />
      <section className="nav-main py-2 d-lg-block d-none">
        <div className="container">
          <div className="row">
            <div className="col-3">
              <img
                onClick={() => navigate("/")}
                className="img-fluid"
                src="/images\real-state-logo.png"
                alt="Logo"
              />
            </div>
            <div className="col-9 nav-col">
              <ul className="nav-ul">
                <li onClick={() => navigate("/")}>Home</li>
                <li onClick={() => navigate("/about-us")}>About Us</li>
                <li className="dropdown nav-dropdown">
                  Property
                  <ul className="dropdown-content">
                    <li onClick={() => { navigate("/property-listing?type=rent&page=1"); setUpdatePage && setUpdatePage(!updatePage) }}>
                      Rent
                    </li>
                    <li onClick={() => { navigate("/property-listing?type=sell&page=1"); setUpdatePage && setUpdatePage(!updatePage) }}>
                      Sell
                    </li>
                    <li onClick={() => { navigate("/property-listing?type=developer&page=1"); setUpdatePage && setUpdatePage(!updatePage) }}>
                      Developer
                    </li>
                  </ul>
                </li>
                <li onClick={() => navigate("/blogs")}>Blogs</li>
                <li onClick={() => navigate("/contact-us")}>Contact Us</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="nav-main py-2 d-lg-none d-block">
        <div className="container">
          <div className="row">
            <div className="col-5">
              <img
                onClick={() => navigate("/")}
                className="img-fluid"
                src="images\real-state-logo.png"
                alt="Logo"
              />
            </div>
            <div className="col-7 nav-col">
              <FaBars onClick={() => setShow(true)} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Navbar;
